import React, { useState } from "react";
import { FaEdit } from "react-icons/fa";

const ImageEditTitle = ({ imageUrl, initialTitle }) => {
  const [title, setTitle] = useState(initialTitle);
  const [isEditing, setIsEditing] = useState(false);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setIsEditing(false);
      console.log("New title:", title); // Log the new title when editing is finished
      // Here you can also add a call to update the database with the new title
    }
  };

  return (
    <div style={{ textAlign: "center" }}>
      <img
        src={imageUrl}
        alt={title}
        style={{ width: "100%", height: "auto" }}
      />
      {isEditing ? (
        <input
          type='text'
          value={title}
          onChange={handleTitleChange}
          onKeyPress={handleKeyPress}
          onBlur={() => {
            setIsEditing(false);
            console.log("New title:", title); // Also log when focus is lost
          }}
        />
      ) : (
        <p onClick={handleEdit}>
          {title}{" "}
          <span style={{ cursor: "pointer" }}>
            {" "}
            <FaEdit color='orange' size={"18"} align='right' />
          </span>
        </p>
      )}
    </div>
  );
};

export default ImageEditTitle;
